import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#0B132B] py-20" data-testid="footer">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img 
                src="/images/logo_transparent.png" 
                alt="KOSS LAB" 
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-[#94a3b8] text-sm leading-relaxed" style={{ fontFamily: 'IBM Plex Sans' }}>Лаборатория спортивной неврологии доктора Косса. Оборудование для восстановления, движения и поддержки тела.</p>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-5" style={{ fontFamily: 'Manrope' }}>Направления</h4>
            <ul className="space-y-3 text-[#94a3b8] text-sm" style={{ fontFamily: 'IBM Plex Sans' }}>
              <li><Link to="/catalog?category=spine-support" className="hover:text-[#14b8a6] transition-colors">Позвоночник и осанка</Link></li>
              <li><Link to="/catalog?category=movement-recovery" className="hover:text-[#14b8a6] transition-colors">Восстановление</Link></li>
              <li><Link to="/catalog?category=muscle-tissue" className="hover:text-[#14b8a6] transition-colors">Мышцы и ткани</Link></li>
              <li><Link to="/catalog?category=neuro-support" className="hover:text-[#14b8a6] transition-colors">Нейроподдержка</Link></li>
              <li><Link to="/catalog?category=sports-rehab" className="hover:text-[#14b8a6] transition-colors">Спорт и реабилитация</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-5" style={{ fontFamily: 'Manrope' }}>Компания</h4>
            <ul className="space-y-3 text-[#94a3b8] text-sm" style={{ fontFamily: 'IBM Plex Sans' }}>
              <li><Link to="/about" className="hover:text-[#14b8a6] transition-colors">Об эксперте</Link></li>
              <li><Link to="/publications" className="hover:text-[#14b8a6] transition-colors">Публикации</Link></li>
              <li><Link to="/b2b" className="hover:text-[#14b8a6] transition-colors">Для клиник</Link></li>
              <li><Link to="/contact" className="hover:text-[#14b8a6] transition-colors">Консультация</Link></li>
              <li><Link to="/privacy" className="hover:text-[#14b8a6] transition-colors">Политика конфиденциальности</Link></li>
              <li><Link to="/terms" className="hover:text-[#14b8a6] transition-colors">Пользовательское соглашение</Link></li>
              <li><Link to="/offer" className="hover:text-[#14b8a6] transition-colors">Публичная оферта</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-5" style={{ fontFamily: 'Manrope' }}>Контакты</h4>
            <ul className="space-y-3 text-[#94a3b8] text-sm" style={{ fontFamily: 'IBM Plex Sans' }}>
              <li className="flex items-center gap-2">
                <span className="text-[#14b8a6]">+7 (926) 599-52-52</span>
              </li>
              <li>info@kosslab.ru</li>
              <li>г. Москва</li>
              <li className="pt-2">
                <a href="https://vkoss.ru" target="_blank" rel="noopener noreferrer" className="text-[#0d9488] hover:text-[#14b8a6] transition-colors font-medium">vkoss.ru</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#64748b] text-sm" style={{ fontFamily: 'IBM Plex Sans' }}>© {new Date().getFullYear()} KOSS LAB — Лаборатория спортивной неврологии</p>
          <div className="flex gap-6 text-[#64748b] text-sm" style={{ fontFamily: 'IBM Plex Sans' }}>
            <Link to="/privacy" className="hover:text-[#14b8a6] transition-colors">Конфиденциальность</Link>
            <Link to="/offer" className="hover:text-[#14b8a6] transition-colors">Оферта</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
